import React, { FC } from 'react';
import { SystemButtonHyperlinkProps } from '../button.types';
import { Hyperlink } from '../../Hyperlink';
import { SystemHyperlinkDefault } from '../systemButtonDefaultProps';
import styles from './text_button.module.scss';
import { SystemButtonContent } from '../SystemButton';

type Props = {
  iconLeft?: string;
  iconRight?: string;
} & SystemButtonHyperlinkProps;

export const TextHyperlink: FC<Props> = ({
  children,
  target,
  href,
  rel,
  source,
  iconLeft,
  iconRight,
  onClick,
}) => {
  return (
    <Hyperlink
      className={styles.text}
      target={target}
      href={href}
      rel={rel}
      source={source}
      onClick={onClick}
    >
      <SystemButtonContent iconLeft={iconLeft} iconRight={iconRight}>
        <span className={styles.content}>{children}</span>
      </SystemButtonContent>
    </Hyperlink>
  );
};

TextHyperlink.defaultProps = SystemHyperlinkDefault;
